var map = {
	"./stage-0.svg": 7690,
	"./stage-1.svg": 5039,
	"./stage-2.svg": 7777,
	"./stage-3.svg": 911,
	"./stage-4.svg": 2321,
	"./stage-5.svg": 17,
	"./stage-6.svg": 2760
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1337;